export default import.meta.ROLLUP_FILE_URL_UtSd2wWiGs0Sim15oE6Xxg;